/**
 * Mission History Feature Constants
 *
 * Centralized constants for mission history feature
 */

import { 
    TrendingUp, 
    CheckCircle2, 
    Clock, 
    Cpu, 
} from 'lucide-react';
import type { MissionStats, Mission } from './types/missionHistory.types';

/**
 * Stats data for mission history
 */
export const MISSION_STATS_DATA: MissionStats[] = [
    {
        title: 'Total Missions',
        value: '7',
        subtitle: '+12% from last week',
        icon: TrendingUp,
        trend: 'up',
    },
    {
        title: 'Success Rate',
        value: '86%',
        subtitle: '6 successful',
        icon: CheckCircle2,
        trend: 'neutral',
    },
    {
        title: 'Total Flight Time',
        value: '347 min',
        subtitle: '~ 6 hours',
        icon: Clock,
        trend: 'neutral',
    },
    {
        title: 'AI Detections',
        value: '487',
        subtitle: 'Across all missions',
        icon: Cpu,
        trend: 'neutral',
    },
];

/**
 * Recent missions mock data
 */
export const RECENT_MISSIONS_DATA: Mission[] = [
    {
        id: 'M-2025-10-17-001',
        name: 'Downtown Infrastructure Scan',
        status: 'success',
        date: 'Oct 17, 2025',
        aiModel: 'Structure Inspection',
        distance: '8.7 km',
        duration: '47 min',
        maxAltitude: '128m',
        drone: 'Pyrhos X V1',
        detections: 23,
    },
    {
        id: 'M-2025-10-16-003',
        name: 'Warehouse Inventory Count',
        status: 'success',
        date: 'Oct 16, 2025',
        aiModel: 'Inventory Count',
        distance: '3.2 km',
        duration: '38 min',
        maxAltitude: '45m',
        drone: 'Caerius',
        detections: 312,
    },
    {
        id: 'M-2025-10-16-004',
        name: 'Bridge Inspection - Highway 101',
        status: 'success',
        date: 'Oct 16, 2025',
        aiModel: 'Structure Inspection',
        distance: '5.8 km',
        duration: '65 min',
        maxAltitude: '78m',
        drone: 'Pyrhos X V1',
        detections: 18,
    },
    {
        id: 'M-2025-10-15-005',
        name: 'Emergency Response - Sector 7',
        status: 'partial',
        date: 'Oct 15, 2025',
        aiModel: 'Search & Rescue',
        distance: '7.1 km',
        duration: '28 min',
        maxAltitude: '142m',
        drone: 'Pyrhos 7',
        detections: 3,
    },
    {
        id: 'M-2025-10-15-006',
        name: 'Construction Site Monitoring',
        status: 'success',
        date: 'Oct 15, 2025',
        aiModel: 'Area Surveillance',
        distance: '9.2 km',
        duration: '43 min',
        maxAltitude: '105m',
        drone: 'AR-2',
        detections: 34,
    },
    {
        id: 'M-2025-10-14-007',
        name: 'Port Security Patrol',
        status: 'success',
        date: 'Oct 14, 2025',
        aiModel: 'Area Surveillance',
        distance: '16.4 km',
        duration: '71 min',
        maxAltitude: '115m',
        drone: 'Stallion',
        detections: 56,
    },
    {
        id: 'M-2025-10-14-008',
        name: 'Solar Farm Inspection',
        status: 'success',
        date: 'Oct 14, 2025',
        aiModel: 'Structure Inspection',
        distance: '11.7 km',
        duration: '55 min',
        maxAltitude: '88m',
        drone: 'Caerius',
        detections: 41,
    },
];

/**
 * Mission type chart data
 */
export const MISSION_TYPE_CHART_DATA = {
    series: [35, 25, 20, 15, 5],
    labels: ['Structure Inspection', 'Crop Health', 'Surveillance', 'Inventory', 'Search & Rescue'],
};

/**
 * Mission duration chart data
 */
export const MISSION_DURATION_CHART_DATA = {
    series: [{ name: 'Duration (min)', data: [35, 65, 25, 45, 70, 55] }],
    categories: ['003', '004', '005', '006', '007', '008'],
};
